export enum BMDProperties {
    INVOICEFEE = "InvoiceFee",
    INTEGRATIONS = "Integrations",
    PROVISIONAMOUNT = "ProvisionSurveillanceMainAmount",
    REMITFILE = "RemitFileFormat",
    OUTPUTINTEGRATION = "OutputIntegration"
}